module.exports = __webpack_public_path__ + "img/CM-MC-25-Toyota-Lifestyle.cca0466d.jpg";